import React from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import amber from '@material-ui/core/colors/amber';
import ReactGA from 'react-ga';
import Auth from './Auth';
import Dashboard from './Dashboard';
import WebDashboard from './WebDashboard';
import { getUrlParameter, setPlanPricing, setCookie } from '../../utils';

const TRACKING_ID = "UA-80270327-2";
ReactGA.initialize(TRACKING_ID);

const qtWindow = Boolean(getUrlParameter('client'));
const qtEngine = getUrlParameter('qtengine');
const engine = getUrlParameter('engine') ? getUrlParameter('engine') : 'asmfish';
const page = getUrlParameter('page');
const plan = getUrlParameter('plan');
const price = setPlanPricing(plan);

if (qtWindow) {
  setCookie('qtEngine', qtEngine)
}

const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: { main: '#009673' },
    secondary: { main: amber[600] },
    contrastThreshold: 3,
    tonalOffset: 0.2
  }
});

function App(props) {
  const { user } = props;
  const { pathname } = window.location;
  let view = null;
  if (qtWindow) {
    view = <Dashboard qtWindow={qtWindow} qtEngine={qtEngine} engine={engine} />
  } else {
    view = <WebDashboard qtWindow={qtWindow} qtEngine={qtEngine} engine={engine} page={page} plan={plan} price={price} />
  }
  return (
    <MuiThemeProvider theme={theme}>
      {user && pathname !== "/verify_account" ? view : <Auth qtWindow={qtWindow} qtEngine={qtEngine} engine={engine} user={user} />}
    </MuiThemeProvider>
  );
}

export default App;
